import axios from "axios";

export const web = axios.create({
	baseURL: `${process.env.REACT_APP_DOMAIN_BASE}`
});

export const api = axios.create({
	baseURL: `${process.env.REACT_APP_DOMAIN_BASE}/api`,
	withCredentials: true,
});